/**
 * Chart Color Constants
 *
 * Static hex values for chart libraries (ApexCharts, etc.) that can't use CSS variables.
 * Source: src/theme/colors.ts (MUI theme)
 */
export const CHART_COLORS = {
  primary: {
    lightest: '#C9D3FC',
    light: '#93A8F9',
    main: '#4C6EF5',
    dark: '#3C58C4',
    darkest: '#26377A',
    alpha4: 'rgba(76, 110, 245, 0.04)',
    alpha8: 'rgba(76, 110, 245, 0.08)',
    alpha12: 'rgba(76, 110, 245, 0.12)',
    alpha30: 'rgba(76, 110, 245, 0.30)',
    alpha50: 'rgba(76, 110, 245, 0.50)',
  },
  secondary: {
    lightest: '#A3EDE2',
    light: '#66DAC3',
    main: '#00C99B',
    dark: '#008E6E',
    darkest: '#004F3C',
    alpha4: 'rgba(0, 201, 155, 0.04)',
    alpha8: 'rgba(0, 201, 155, 0.08)',
    alpha12: 'rgba(0, 201, 155, 0.12)',
    alpha30: 'rgba(0, 201, 155, 0.30)',
    alpha50: 'rgba(0, 201, 155, 0.50)',
  },
  success: {
    lightest: '#F0FDF9',
    light: '#3FC79A',
    main: '#10B981',
    dark: '#0B815A',
    darkest: '#134E48',
    alpha4: 'rgba(16, 185, 129, 0.04)',
    alpha8: 'rgba(16, 185, 129, 0.08)',
    alpha12: 'rgba(16, 185, 129, 0.12)',
    alpha30: 'rgba(16, 185, 129, 0.30)',
    alpha50: 'rgba(16, 185, 129, 0.50)',
  },
  warning: {
    lightest: '#FFFAEB',
    light: '#FEF0C7',
    main: '#F79009',
    dark: '#B54708',
    darkest: '#7A2E0E',
    alpha4: 'rgba(247, 144, 9, 0.04)',
    alpha8: 'rgba(247, 144, 9, 0.08)',
    alpha12: 'rgba(247, 144, 9, 0.12)',
    alpha30: 'rgba(247, 144, 9, 0.30)',
    alpha50: 'rgba(247, 144, 9, 0.50)',
  },
  error: {
    lightest: '#FEF3F2',
    light: '#FEE4E2',
    main: '#F04438',
    dark: '#B42318',
    darkest: '#7A271A',
    alpha4: 'rgba(240, 68, 56, 0.04)',
    alpha8: 'rgba(240, 68, 56, 0.08)',
    alpha12: 'rgba(240, 68, 56, 0.12)',
    alpha30: 'rgba(240, 68, 56, 0.30)',
    alpha50: 'rgba(240, 68, 56, 0.50)',
  },
  info: {
    lightest: '#ECFDFF',
    light: '#CFF9FE',
    main: '#06AED4',
    dark: '#0E7090',
    darkest: '#164C63',
    alpha4: 'rgba(6, 174, 212, 0.04)',
    alpha8: 'rgba(6, 174, 212, 0.08)',
    alpha12: 'rgba(6, 174, 212, 0.12)',
    alpha30: 'rgba(6, 174, 212, 0.30)',
    alpha50: 'rgba(6, 174, 212, 0.50)',
  },
  neutral: {
    50: '#F8F9FA',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D2D6DB',
    400: '#9DA4AE',
    500: '#6C737F',
    600: '#4D5761',
    700: '#2F3746',
    800: '#1C2536',
    900: '#111927',
  },
} as const;
